<template>
  <div class="form-group">
    <div class="custom-align-item" :class="{ active: value === 'left', dark: theme === 'dark' }"
      @click="chooseAlign('left')">
      <i :class="alignLeftIcon" />
    </div>
    <div v-if="!disableCenter" class="custom-align-item" :class="{ active: value === 'center', dark: theme === 'dark' }"
      @click="chooseAlign('center')">
      <i :class="alignCenterIcon" />
    </div>
    <div class="custom-align-item" :class="{ active: value === 'right', dark: theme === 'dark' }"
      @click="chooseAlign('right')">
      <i :class="alignRightIcon" />
    </div>
  </div>
</template>

<script>
import { ALIGNCENTER_ICON, ALIGNLEFT_ICON, ALIGNRIGHT_ICON } from '@src/icons'
export default {
  props: {
    value: { required: false, type: [String], default: '' },
    disableCenter: { type: Boolean, default: false },
    theme: { type: String, default: undefined },
  },
  data() {
    return {
      alignLeftIcon: ALIGNLEFT_ICON,
      alignCenterIcon: ALIGNCENTER_ICON,
      alignRightIcon: ALIGNRIGHT_ICON
    }
  },
  methods: {
    chooseAlign(align) { this.$emit('input', align) }
  }
}
</script>

<style lang="scss">
.custom-align-item {
  display: inline-block;
  border: 1px solid transparent;
  padding: 3px 5px 0px 5px;
  cursor: pointer;
  border-radius: 5px;
  margin-right: 6px;

  i {
    color: rgba(0, 27, 72, 0.54);
    font-size: 20px;
  }

  &.active {
    border-color: rgba(0, 27, 72, 0.12);
    color: rgba(0, 14, 36, 0.87);
  }

  &.dark {
    &.active {
      border-color: rgba(0, 27, 72, 0.12);
      background-color: #3b5998

      i {
        color: #fff;
      }
    }
  }
}</style>